export const groupSlotsByDay = slots => {
  if (Array.isArray(slots)) {
    const splitForTime = slots.reduce((state, item) => {
      const day = item.startTime.match(/\d{4}-\d{2}-\d{2}/)[0];
      (state[day] && state[day].push(item)) || (state[day] = [item]);
      return state;
    }, {});

    const result = [];
    for (const key in splitForTime) {
      result.push({ title: key, items: splitForTime[key] });
    }
    return result;
  }
  return [];
};

export const parsePatientTypeUG = userExternalDate => {
  if (userExternalDate) {
    if (userExternalDate && userExternalDate.ultraGendaId) {
      // temp user and only now created
      return { ultraGendaId: userExternalDate.ultraGendaId };
    } else if (userExternalDate && typeof userExternalDate.isTemporary === 'boolean') {
      if (userExternalDate.isTemporary) {
        // temp in UG
        return { ultraGendaId: userExternalDate.number };
      } else {
        // user approve in UG
        return { masterPatientIndex: userExternalDate.number };
      }
    }
  }
};
